export default __webpack_public_path__ + "static/media/create_resource_group.06ee7d36.png";